import { useEffect, useState } from 'react'
import { getAuthCookie } from 'src/utils/cookies'

function readIdentity<T>(): T | null {
  try {
    const authCookie = getAuthCookie()
    if (!authCookie) return null
    return JSON.parse(authCookie) as T
  } catch {
    return null
  }
}

export type UseIdentityResult<T> = {
  data: T | null
  isLoading: boolean
}

export function useIdentity<T = unknown>(): UseIdentityResult<T> {
  const [data, setData] = useState<T | null>(() => readIdentity<T>())
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    setData(readIdentity<T>())
    setIsLoading(false)
  }, [])

  return { data, isLoading }
}
